import { memo } from 'react';
import useGoToRoute from 'src/hooks/useGoToRoute';
import { cm } from 'src/utils/classNames';
import {
	LendBorrow,
	IFStaking,
	Amplify,
	ArrowRight,
	Overview,
	IconProps,
} from '@drift-labs/icons';
import React from 'react';
import { getColorVar } from 'src/utils/theme/colorVars';

const AboutDriftEarnSection = () => {
	return (
		<div className="col-span-12 mt-3xl grid grid-cols-subgrid gap-y-lg">
			<div className="col-span-12">
				<span className={'typo-t1 text-text-default'}>About Drift Earn</span>
			</div>
			<ArticleItem
				className="col-span-12 sm:col-span-3"
				title={'Borrow/Lend'}
				description={'Deposits automatically earn interest from borrows.'}
				IconComponent={LendBorrow}
				url={'https://docs.drift.trade/lend-borrow/what-is-lend-borrow'}
			/>
			<ArticleItem
				className="col-span-12 sm:col-span-3"
				IconComponent={Overview}
				description={
					'Lend and borrow with isolated pools to manage risk, access diverse assets, and minimize cross-asset exposure.'
				}
				title={'Isolated Pool'}
				url={'https://docs.drift.trade/lend-borrow/isolated-pools'}
			/>
			<ArticleItem
				className="col-span-12 sm:col-span-3"
				IconComponent={IFStaking}
				description={
					'Stake your assets into an insurance fund vault and earn a portion of exchange fees.'
				}
				title={'Insurance Fund Vaults'}
				url={'https://docs.drift.trade/insurance-fund/insurance-fund-intro'}
			/>
			<ArticleItem
				className="col-span-12 sm:col-span-3"
				IconComponent={Amplify}
				description={
					'Amplify your earnings up to 5x effortlessly, with the same deposit amount.'
				}
				title={'Amplify'}
				url={'https://docs.drift.trade/amplify/how-it-works'}
			/>
		</div>
	);
};

const ArticleItem = ({
	IconComponent,
	title,
	description,
	url,
	className,
}: {
	IconComponent: React.ComponentType<IconProps>;
	title: string;
	description: string;
	url: string;
	className?: string;
}) => {
	const goToRoute = useGoToRoute();

	return (
		<div
			className={cm(
				'group w-full rounded-md border border-stroke-divider bg-container-bg hover:cursor-pointer hover:bg-button-disabled',
				className
			)}
			onClick={(e) => {
				e.stopPropagation();
				goToRoute(url);
			}}
		>
			<div className="flex h-full min-h-[252px] flex-col gap-y-lg p-6">
				<div className="flex flex-col gap-y-xs">
					<div className="flex items-center justify-start text-text-default">
						<IconComponent size={32} />
					</div>
					<span className={'typo-h5 text-text-default'}>{title}</span>
				</div>

				<span className="typo-b2 text-text-secondary group-hover:text-text-default">
					{description}
				</span>

				<div className={cm('mt-auto flex items-center')}>
					<span className="typo-t3 text-text-secondary group-hover:text-purple-link">
						Learn More
					</span>
					<ArrowRight
						size={16}
						color={getColorVar('purple-link')}
						className="ml-1 -translate-x-xs opacity-0 transition-all duration-200 group-hover:translate-x-0 group-hover:opacity-100"
					/>
				</div>
			</div>
		</div>
	);
};

export default memo(AboutDriftEarnSection);
